import { store, getElement, withScope } from "@wordpress/interactivity";

let loadedIds = new Set();

const { state, actions } = store("dock11/kreative-koepfe", {
    state: {
        get showEmptyState() {
            const hasActiveFilters =
                state.currentSearch.length > 0 ||
                state.currentSectors.length > 0;
            return (
                hasActiveFilters && state.users.length === 0 && !state.loading
            );
        },
        get loadMoreLabel() {
            return state.loadingMore ? "Lade mehr..." : state.loadMoreText;
        },
    },
    actions: {
        *loadMore() {
            if (state.loadingMore || !state.hasMore) return;

            state.loadingMore = true;
            state.currentPage++;

            try {
                const params = new URLSearchParams();
                params.append("page", state.currentPage);
                if (state.currentSearch) {
                    params.append("find", state.currentSearch);
                }
                if (state.currentSectors.length > 0) {
                    state.currentSectors.forEach((s) =>
                        params.append("sector[]", s),
                    );
                }

                const response = yield fetch(
                    `/wp-json/dock11/v1/users?${params}`,
                    { credentials: "same-origin" },
                );
                const total = parseInt(
                    response.headers.get("X-WP-Total") || "-1",
                    10,
                );
                const data = yield response.json();

                if (Array.isArray(data)) {
                    const newUsers = data.filter((u) => !loadedIds.has(u.ID));
                    newUsers.forEach((u) => loadedIds.add(u.ID));
                    state.users = [...state.users, ...newUsers];
                    state.hasMore =
                        total >= 0
                            ? loadedIds.size < total
                            : newUsers.length > 0;
                }
            } catch (e) {
                console.error("Error loading more users:", e);
            } finally {
                state.loadingMore = false;
            }
        },
        *handleFilterChange(detail) {
            state.currentSearch = detail.search || "";
            state.currentSectors = detail.sectors || [];
            state.currentPage = 1;
            loadedIds.clear();
            state.hasMore = true;
            state.loading = true;

            try {
                const params = new URLSearchParams();
                if (state.currentSearch) {
                    params.append("find", state.currentSearch);
                }
                if (state.currentSectors.length > 0) {
                    state.currentSectors.forEach((s) =>
                        params.append("sector[]", s),
                    );
                }

                const response = yield fetch(
                    `/wp-json/dock11/v1/users?${params}`,
                    { credentials: "same-origin" },
                );
                const total = parseInt(
                    response.headers.get("X-WP-Total") || "-1",
                    10,
                );
                const data = yield response.json();

                if (Array.isArray(data)) {
                    data.forEach((u) => loadedIds.add(u.ID));
                    state.users = data;
                    state.hasMore =
                        total >= 0
                            ? total > state.numberOfItems
                            : data.length >= state.numberOfItems;
                }
            } catch (e) {
                console.error("Error filtering users:", e);
            } finally {
                state.loading = false;
            }
        },
    },
    callbacks: {
        init() {
            // Seed loadedIds from server-rendered initial users
            state.users.forEach((u) => loadedIds.add(u.ID));

            // Respond to user-filter changes
            document.addEventListener(
                "user-filter-change",
                withScope((event) => {
                    actions.handleFilterChange(event.detail);
                }),
            );
        },
    },
});
